import { render, staticRenderFns } from "./channelDepartment.vue?vue&type=template&id=64123697&scoped=true&"
import script from "./channelDepartment.vue?vue&type=script&lang=js&"
export * from "./channelDepartment.vue?vue&type=script&lang=js&"
import style0 from "./channelDepartment.vue?vue&type=style&index=0&id=64123697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64123697",
  null
  
)

export default component.exports